// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"TitleBar-module--titleContainer--1-H10","title":"TitleBar-module--title--24Y5W"};